import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { Injectable, Provider } from '@angular/core';

import {
    ClientConfig,
    ClientConfigProductName,
    ClientConfigService,
    STORE_PREFIX,
    CurrencyPipe as VanillaCurrencyPipe,
    runOnAppInit,
} from '@frontend/vanilla/core';

import { SamePathAppVersion } from './app.version.enum';
import { HostBootstrapper } from './bootstrapper';
import { provideMaintenance } from './maintenance/maintenance.provide';

@ClientConfig({ key: 'haApp', product: ClientConfigProductName.HOST })
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService],
    useFactory: hostAppConfigFactory,
})
export class HostAppConfig {
    defaultPath: string;
    defaultProduct: string;
    allowedPaths: string[];
    samePathAppVersions: { [key: string]: SamePathAppVersion };
    productPathMap: { [key: string]: string };
    configuredProducts: string[];
    correlationId: string;
}

export function hostAppConfigFactory(service: ClientConfigService) {
    return service.get(HostAppConfig);
}

export function provideHostApp(): Provider[] {
    return [
        { provide: STORE_PREFIX, useValue: 'host.' },
        provideMaintenance(),
        runOnAppInit(HostBootstrapper),
        CurrencyPipe,
        VanillaCurrencyPipe,
        DatePipe,
        PercentPipe,
    ];
}
